<!--
 * @Author: 么东欣
 * @Date: 2022-03-04 16:28:11
 * @LastEditTime: 2022-06-13 18:32:47
 * @LastEditors: 么东欣
 * @Description: iosSelect
 * @FilePath: /src/components/select/index.vue
-->
<template>
  <div class="c-select" :class="classStr" @click="selectBtn">
    <slot name="prefix"></slot>
    <span class="label">
      {{ label }}
      <i class="star" v-show="required">*</i>
    </span>
    <div class="c-content c-placeholder" v-if="showPlaceholder">{{ placeholder }}</div>
    <div v-else class="c-content single-ellipsis" style="color: #333333">
      <span v-for="(v, index) in value" :key="index">
        <span class="c-font0">
          <span v-if="index > 0">{{separation}}</span>
          <span>{{ v ? v[valueKey] : '' }}</span>
        </span>
      </span>
    </div>
    <i
      @click="clear"
      v-show="clearable && modelValue != '' && modelValue != null"
      class="iconfont icon-shanchujiaobiao"
    ></i>
    <slot name="suffix"></slot>
  </div>
  <div class="container"></div>
</template>
<script>
import IosSelect from './src/js/iosSelect.js'
import './src/css/iosSelect.css'
export default {
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [Array, Object],
      default: () => [],
    },
    valueKey: {
      type: String,
      default: 'value',
    },
    idKey: {
      type: String,
      default: 'id',
    },
    pidKey: {
      type: String,
      default: 'parentId',
    },
    label: {
      type: String,
      default: '标签',
    }, //label
    placeholder: {
      type: String,
      default: '请选择',
    }, //原生属性
    clearable: {
      type: Boolean,
      default: false,
    }, //Todo...
    disabled: {
      type: Boolean,
      default: false,
    }, //原生属性
    readonly: {
      type: String,
      default: '',
    }, //原生属性，是否只读
    outline: {
      type: Boolean,
      default: false,
    }, //全边框输入框
    size: {
      type: String,
      default: 'middle', //large big middle small xs
    },
    placeholderColor: {
      type: String,
      default: '#979797',
    },
    // 级联层级
    level: {
      type: [Number, String],
      default: 1,
    },
    sourceData: {
      type: [Array],
      default: () => {
        return []
      },
    },
    relation: {
      type: Array,
      default: () => [],
    },
    separation: {
      type: String,
      default: ' ',
    },
  },
  emits: ['change', 'clear', 'update:modelValue'],
  computed: {
    showPlaceholder() {
      let showPlaceholder = true
      if (
        Object.prototype.toString.apply(this.modelValue) == '[object Array]'
      ) {
        if (this.modelValue.length > 0) {
          showPlaceholder = false
        } else {
          showPlaceholder = true
        }
      } else if (
        Object.prototype.toString.apply(this.modelValue) == '[object Object]'
      ) {
        if (!!this.modelValue[this.valueKey] || !!this.modelValue[this.idKey]) {
          showPlaceholder = false
        } else {
          showPlaceholder = true
        }
      } else {
        showPlaceholder = true
        console.error('select value type error!')
      }
      return showPlaceholder
    },
  },
  data() {
    return {
      classArr: [],
      classStr: '',
      levelLetters: ['one', 'two', 'three', 'four', 'five', 'six'],
      selectObj: null,
      value: [],
    }
  },
  watch: {
    modelValue(v) {
      this.init(v)
    },
  },
  mounted() {
    this.classUpdate()
    this.init(this.modelValue)
  },
  updated() {
    this.classUpdate()
  },
  methods: {
    classUpdate() {
      this.classArr = []
      this.disabled && this.classArr.push('disabled') //Todo...
      this.readonly && this.classArr.push('readonly') //Todo...
      this.outline && this.classArr.push('outline')
      this.required && this.classArr.push('required')
      this.clearable && this.classArr.push('clearable') //Todo...
      this.classArr.push(this.size ? this.size : 'middle')
      // this.classArr.push(this.type) // Todo...
      this.classStr = this.classArr.join(' ')
    },
    init(v) {
      this.value = []
      if (Object.prototype.toString.apply(v) == '[object Array]') {
        for (let i = 0; i < this.level; i++) {
          this.value.push(v[i])
        }
      } else {
        this.value = [v]
      }
    },
    change(v) {
      if (this.disabled || this.readonly) return
      this.init(v)
      this.$emit('change', this.value)
      this.$emit('update:modelValue', this.value)
    },
    clear() {
      this.$emit('update:modelValue', '')
      this.$emit('change', '')
    },
    selectBtn() {
      if (this.disabled || this.readonly) return
      if (
        Object.prototype.toString.apply(this.sourceData) != '[object Array]'
      ) {
        this.$toaster({
          message: '获取数据源失败',
        })
        return
      } else {
        if (this.sourceData.length == 0) {
          this.$toaster({
            message: '获取数据源失败',
          })
          return
        }
      }
      let levelIds = {}
      let sourceData
      if (this.level == 1) {
        sourceData = [this.sourceData]
        levelIds = {
          oneLevelId:
            Object.prototype.toString.apply(this.modelValue) == '[object Array]'
              ? this.modelValue[0] && this.modelValue[0][this.idKey]
                ? this.modelValue[0][this.idKey]
                : sourceData[0][0][this.idKey]
              : this.modelValue && this.modelValue[this.idKey]
              ? this.modelValue[this.idKey]
              : sourceData[0][0][this.idKey],
        }
      } else if (this.level > 1) {
        sourceData = this.sourceData
        for (let i = 0; i < this.level; i++) {
          let letter = this.levelLetters[i]
          let v =
            this.modelValue[i] && this.modelValue[i][this.idKey]
              ? this.modelValue[i][this.idKey]
              : this.sourceData[i][0][this.idKey]
          levelIds[letter + 'LevelId'] = v
        }
      }
      this.selectObj = new IosSelect(
        this.level, // 第一个参数为级联层级，演示为1
        sourceData, // 演示数据
        {
          container: '.container', // 容器class
          title: this.placeholder, // 标题
          itemHeight: 50, // 每个元素的高度
          relation: this.relation,
          itemShowCount: 4, // 每一列显示元素个数，超出将隐藏
          // oneLevelId: val, // 第一级默认值
          ...levelIds,
          callback: (...args) => {
            // 用户确认选择后的回调函数
            this.change(args)
          },
        }
      )
    },
  },
  deactivated() {
    this.selectObj = null
  },
}
</script>

<style lang="less" scoped>
/**输入框 */
.c-select {
  display: flex;
  justify-content: space-between;
  color: #333;
  font-size: 30px;
  line-height: 100px;
  border-bottom: 1px solid #e9e9e9;
  background: #fff;

  // div {
  // 	font-size: 30px;
  // 	text-align: right;
  // 	padding: 0 20px;
  // 	flex: 1 0 0;
  // 	background: none;
  // }
}

.c-content {
  flex: 1;
  text-align: right;
  margin-right: 15px;
}

/**边框输入框 */
.c-select.outline {
  height: 88px;
  border-radius: 8px;
  border: 2px solid #e4e4e4;
  padding: 0 20px;
  line-height: 86px;
}

.star {
  font-style: normal;
  font-size: 28px;
  color: #f60e0e;
  line-height: 28px;
}

.icon-shanchujiaobiao {
  font-size: 28px;
  color: #aaaaaa;
}

.icon-shanchujiaobiao {
  font-size: 28px;
  color: #aaaaaa;
}

.c-placeholder {
  font-size: 30px;
  color: v-bind(placeholderColor);
}
.c-font0 {
  font-size: 0;
  span {
    font-size: 30px;
  }
}
</style>